import script from "./UploadChartOfAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadChartOfAccount.vue?vue&type=script&setup=true&lang=js"

import "./UploadChartOfAccount.vue?vue&type=style&index=0&id=70fc9197&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70fc9197"]])

export default __exports__